import { render, staticRenderFns } from "./GroundTypesView.vue?vue&type=template&id=0bd52f4e&"
import script from "./GroundTypesView.vue?vue&type=script&lang=ts&"
export * from "./GroundTypesView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports